import { type Scale } from '@styled-system/core';
import { px } from '../utilites';
import { isKosmosToken, getThemeFromPropsArray, getTokenValue } from '../utils';
import { getFontSize as getRagnarFontSize } from '../../';

export function getFontSize(
  n: string,
  scale?: Scale,
  ...props: any
): string | undefined {
  if (n === '' || !scale) return;

  if (!isKosmosToken(n, scale)) {
    const theme = getThemeFromPropsArray(props);
    return getRagnarFontSize(n, theme.fontSizes);
  }
  return px(getTokenValue(scale, n));
}
